<template>
  <div
    :class="{'aside': noStyle}"
    class="language-list">
    <div class="language-choice"
      :class="{'active': isLanguageActive('th')}"
      @click="onChangeLang('th')">
      <div class="flag-th"></div>
      ภาษาไทย
      <i class="fas fa-check"></i>
    </div>
    <div class="language-choice"
      :class="{'active': isLanguageActive('en')}"
      @click="onChangeLang('en')">
      <div class="flag-en"></div>
      English
      <i class="fas fa-check"></i>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    noStyle: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  computed: {
    ...mapGetters(['userLanguage']),
  },
  methods: {
    isLanguageActive(lang) {
      return this.userLanguage === lang;
    },
    onChangeLang(lang) {
      this.$store.dispatch('setUserLanguage', lang);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/variables.scss';

.language-list {
  margin-top: $spacer * 0.25;
  padding: 0 10px 14px 10px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid $dark-400;

  .language-choice {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    text-align: center;
    font-size: $font-size-sm;
    padding: 4px 8px;
    transition: all 0.2s ease-out;
    color: #FFF;
    border: 1px solid transparent;
    border-radius: 100px;
    cursor: pointer;

    .flag-th {
      display: inline-block;
      background: url("~@/assets/images/TH.svg") no-repeat 50% 50%;
      background-size: 120%;
      width: 20px;
      height: 20px;
      border-radius: 100%;
      margin-right: 4px;
    }

    .flag-en {
      display: inline-block;
      background: url("~@/assets/images/EN.svg") no-repeat 50% 50%;
      background-size: 120%;
      width: 20px;
      height: 20px;
      border-radius: 100%;
      margin-right: 4px;
    }

    i {
      display: none;
      margin-left: 5px;
      color: #FFF;
    }

    &:hover {
      color: #FFF;
      border: 1px solid $dark-400;
      background-color: $dark-400;
    }

    &.active {
      color: #FFF;
      border: 1px solid $dark-400;
      background-color: $dark-active-tab;
      i {
        display: inline-block;
      }
      &:hover {
        cursor: default;
      }
    }
  }

  &.aside {
    padding: $spacer 0;
    border-bottom: 0;
  }
}

</style>
